import { DataTable } from 'primereact/datatable'
import {
  Btn,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  Periodo,
} from '../../../../../components'
import React, { useEffect, useState } from 'react'
import { Column } from 'primereact/column'
import { getPeriodoMesAtual, parseToMysqlFormat } from '../../../../../services/util/date.service'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { BadgeTypeOperacoesEstoque } from './MovimentacaoEstoqueAvulso'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../../assets/js/styles'

export default function ModalMovimentacaoEstoqueAvulsoRelatorio({
  isVisible,
  onClose,
  selectedTp,
  operacoes,
  dispatch,
}) {
  const [state, setState] = useState({
    movimentacoes: null,
    selectedMovimentacoes: [],
    selectedOperacao: null,
    periodo: getPeriodoMesAtual(),
    errorMessage: null,
  })

  useEffect(() => {
    setState({
      movimentacoes: null,
      selectedMovimentacoes: [],
      selectedOperacao: null,
      periodo: getPeriodoMesAtual(),
    })
  }, [isVisible])

  function getMovimentacoesAvulso(tpId, pInicial, pFinal, selectedOperacao, dispatch) {
    if (!selectedOperacao)
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Selecione uma operação antes de pesquisar',
      }))
    else {
      EstoqueHttp.getMovimentacoesAvulsoOnPeriodo(
        tpId,
        parseToMysqlFormat(pInicial),
        parseToMysqlFormat(pFinal),
        selectedOperacao.id,
      )
        .then(res => setState(prevState => ({ ...prevState, movimentacoes: res })))
        .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
    }
  }

  function generateRelatorios(selectedMovimentacoes, selectedOperacao) {
    if (!selectedMovimentacoes.length)
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Selecione pelo menos 1 item para gerar o relatório',
      }))
    else {
      const movimentacoesIds = selectedMovimentacoes.map(m => m.movimentao_estoque_info_items_id)
      EstoqueHttp.emitirRelatorioAvulso(selectedTp, movimentacoesIds, selectedOperacao.id)
    }
  }

  const optionTemplate = option => {
    return (
      <div style={{ display: 'flex' }}>
        <span style={{ float: 'right', margin: '.5em .25em 0 0' }}>{option.name}</span>
        <BadgeTypeOperacoesEstoque status={option.type} />
      </div>
    )
  }

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({ ...prevState, errorMessage: null }))
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Relatório de Movimentações Avulso"
      isVisible={isVisible}
      onClose={onClose}
      width={900}
    >
      <div className="p-grid">
        <div className="p-col-3">
          <CustomDropdown
            placeholder="Selecione uma Operação"
            optionLabel={'name'}
            options={operacoes}
            itemTemplate={option => optionTemplate(option)}
            label={'Operação de Estoque'}
            onChange={value => setState(prevState => ({ ...prevState, selectedOperacao: value }))}
            value={state.selectedOperacao}
          />
        </div>
        <div className="p-col-9">
          <Periodo
            periodoInicial={state.periodo.dataInicial}
            periodoFinal={state.periodo.dataFinal}
            onPesquisar={(pInicial, pFinal) =>
              getMovimentacoesAvulso(selectedTp, pInicial, pFinal, state.selectedOperacao)
            }
          />
        </div>
        <div className="p-col-3">
          <Btn
            onClick={() => generateRelatorios(state.selectedMovimentacoes, state.selectedOperacao)}
          >
            Emitir Relatório
          </Btn>
        </div>
      </div>
      <DataTable
        value={state.movimentacoes}
        paginator={true}
        selection={state.selectedMovimentacoes}
        globalFilter={state.globalFilter}
        header={
          <CustomDataTableHeader
            onChange={value => setState(prevState => ({ ...prevState, globalFilter: value }))}
          />
        }
        onSelectionChange={e =>
          setState(prevState => ({ ...prevState, selectedMovimentacoes: e.value }))
        }
        rows={10}
      >
        <Column selectionMode="multiple" style={{ width: '3em' }} />
        <Column field="estoque_name" header="Estoque" style={tableCellCentered()} />
        <Column field="endereco" header="Posição" style={tableCellCentered()} />
        <Column field="product_name" header="Produto" />
        <Column field="validade" header="Validade" style={tableCellCentered()} />
        <Column field="lote" header="Lote" style={tableCellCentered(80)} />
        <Column field="quantidade" header="Qte" style={tableCellCentered(80)} />
        <Column
          field="data_movimentacao"
          header="Data Movimentação"
          style={tableCellCentered(130)}
        />
      </DataTable>
    </CustomModal>
  )
}
